
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue'; 

import useCategorias from '@/modules/ventas/composables/useCategorias';

export default {
    components: {
        CategoriaEditarComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/CategoriaEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerCategorias,
        } = useCategorias();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Nombre', value: 'nombre', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let categorias: any = [];
        const categoriasFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const categoriaEditarComponentRef = ref();

        onMounted(async() => {
            await buscarCategorias();
        });

        const buscarCategorias = async () => {
            const resp = await obtenerCategorias(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                categorias = resp.data;
                categoriasFiltrados.value = JSON.parse(JSON.stringify(categorias));
            }
        }

        const nuevaCategoria = async () => {
            categoriaEditarComponentRef.value.abrirComponent();
        }

        const editarCategoria = async (categoria: any) => {
            categoriaEditarComponentRef.value.abrirComponent(JSON.parse(JSON.stringify(categoria)));
        }

        const filtrarInformacion = async () => {
            categoriasFiltrados.value = JSON.parse(JSON.stringify(
                categorias.filter(
                    (u: any) => u.nombre.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarCategoriaComponentEmit = async(seGrabo: boolean) => {
            if (seGrabo) {
                await buscarCategorias();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            categoriasFiltrados,

            buscarCategorias,
            editarCategoria,
            filtrarInformacion,
            nuevaCategoria,

            categoriaEditarComponentRef,
            cerrarEditarCategoriaComponentEmit,
        };
    }
}
